export enum Actions {
  accept = 'accept',
  locale = 'locale',
  save = 'save',
  settings = 'settings',
  toggle = 'toggle',
  view = 'view'
}